import Vue from 'vue'
import {
  Loading,
  // Message,
  // MessageBox,
  Notification,
  Button,
  Tabs,
  TabPane,
  Select,
  Option,
  Pagination,
  Dialog,
  Input,
  Slider,
  Icon,
  Popover,
  Table,
  TableColumn,
  Breadcrumb,
  BreadcrumbItem,
  Image,
  DatePicker,
  Form,
  FormItem,
  Checkbox,
  Scrollbar,
  Tooltip
} from 'element-ui'

Vue.prototype.$ELEMENT = {
  size: 'medium',
  zIndex: 1200
}

Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Select)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Image)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(Scrollbar)
Vue.use(Tooltip)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
// Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
